var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.absence.backup1_until)?_c('ws-chip',{attrs:{"is-disabled":_vm.isDisabled},model:{value:(_vm.backupUntil),callback:function ($$v) {_vm.backupUntil=$$v},expression:"backupUntil"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }